import { FormControl, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { JobPhaseStatus } from "generated/graphql";
import useUpdateJobPhaseStatus from "hooks/jobs/job-phases/useUpdateJobPhaseStatus";
import { capitalCase } from "change-case";

const ORDERED_STATUSES = [
  JobPhaseStatus.TO_BE_SCHEDULED,
  JobPhaseStatus.SCHEDULED,
  JobPhaseStatus.IN_PROGRESS,
  JobPhaseStatus.WORK_COMPLETE,
  JobPhaseStatus.JOB_COSTING,
  JobPhaseStatus.READY_TO_BILL,
  JobPhaseStatus.COMPLETE,
];

export default function ViewStatusSelect({
  jobPhaseId,
  status,
}: {
  jobPhaseId: string;
  status?: string | null;
}) {
  const [updateJobPhaseStatus, { loading }] = useUpdateJobPhaseStatus({
    id: jobPhaseId,
  });

  const handleStatusChange = (event: SelectChangeEvent) => {
    const newStatus = event.target.value;

    updateJobPhaseStatus({
      variables: {
        id: jobPhaseId,
        status: JobPhaseStatus[newStatus.toUpperCase()],
      },
    });
  };

  return (
    <FormControl sx={{ minWidth: 200 }}>
      <Select
        value={status || ""}
        onChange={handleStatusChange}
        disabled={loading}
        sx={{
          height: "36px",
          borderRadius: 0,
          padding: "15px 20px 15px 0px",
          "& .MuiSelect-select": {
            padding: 0,
            paddingRight: "32px !important",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderRadius: 0,
          },
        }}
      >
        {ORDERED_STATUSES.map((orderedStatus) => (
          <MenuItem key={orderedStatus} value={orderedStatus}>
            {capitalCase(orderedStatus)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
